import React, { FC, ReactElement } from 'react'
import ReactDOM from 'react-dom'
import '@fs/react-scripts/polyfills'
import * as Sentry from '@sentry/browser'
import { addTranslations, setAppLocales, essentialLocales } from '@fs/zion-locale'
import { setEx } from '@fs/zion-experiments'
import Root from '@fs/zion-root'
import { Router } from '@fs/zion-router'
import { appPath, sentryDSN } from '@fs/zion-config'
import { AppLayout, colors } from '@fs/zion-ui'
import { getSentryConfig } from '@fs/tree-config'
import App from './App'
import * as serviceWorker from './serviceWorker'
import AncestorsHeader from './components/AncestorsHeader/AncestorsHeader'
import AncestorsFooter from './components/AncestorsFooter/AncestorsFooter'
import translations from './locales'

// initialize Sentry for the app
if (sentryDSN) {
  // pass Sentry overrides to mergeSentryConfig
  Sentry.init(
    getSentryConfig({
      ignoreErrors: [],
      sampleRate: 0.05,
    })
  )
}

// For details about loading translations: https://www.familysearch.org/frontier/docs/develop/i18n
setAppLocales(essentialLocales)
addTranslations(translations)

// TODO: Take this out once cookies can be passed through CloudFront
if (['ancestors.familysearch.org', 'www.familysearch.org'].includes(window?.location?.hostname)) {
  setEx('AnalyticsFt', true)
  setEx('AdobeLaunchFt', true)
}

// This is where you pass data from the server to the client using the SERVER_DATA global.
// Here we pass the mounted app path from the server to the client.
const base = appPath ? new URL(appPath).pathname : ''
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const state = (window as any).SERVER_DATA.ssrState

const FrontierRoot: FC = (): ReactElement => {
  return (
    <React.StrictMode>
      <Router basename={base}>
        <Root analytics header={false} footer={false}>
          <AppLayout fullWidth backgroundColor={colors.billboard.gray03}>
            <AncestorsHeader />
            <App pid={state?.pid} initialData={state?.initialData} />
            <AncestorsFooter />
          </AppLayout>
        </Root>
      </Router>
    </React.StrictMode>
  )
}

if (state) {
  ReactDOM.hydrate(<FrontierRoot />, document.getElementById('root'))
} else {
  ReactDOM.render(<FrontierRoot />, document.getElementById('root'))
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
